import {
    ChangeDetectionStrategy,
    Component, ElementRef, EventEmitter, Inject, Input, Output, PLATFORM_ID, QueryList, ViewChild, ViewChildren, OnInit,
    SimpleChanges, OnChanges, OnDestroy,
    model
} from '@angular/core';
import {Constants} from '../../../admin-core/constants';
import {AlertService, DebugLoggerService, HelperService, SubscribersService} from '../../../admin-core/services';
import {SampleRequestUpdateService} from '../../../admin-core/services/sample-request-update.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmModalComponent} from '../../../admin-core/components/confirm-modal/confirm-modal.component';
import {ProductsService, QuoteOrderSampleService} from '../../../admin-core/apiservices';
import {isPlatformBrowser, NgClass, NgStyle} from '@angular/common';
import {NgbModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {
    UploadSamplePackingImageModalNewComponent
} from '../modal/upload-sample-packing-image-modal-new/upload-sample-packing-image-modal-new.component';
import {DndDropEvent, DndModule} from 'ngx-drag-drop';
import {Subject, takeUntil} from 'rxjs';
import {QuoteService} from 'src/app/admin-core/apiservices/quote.service';
import {RequestParamModel} from '../../../admin-core/models';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';
import {WebcamModule} from 'ngx-webcam';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {
    ProductImageSliderModalComponent
} from '../modal/product-image-slider-modal/product-image-slider-modal.component'
import {
    UpdateSampleProductNotesModalComponent
} from '../modal/update-sample-product-notes-modal/update-sample-product-notes-modal.component'

@Component({
    selector: 'app-product-detail',
    // Eager: Angular 22 defaults every component to OnPush, which would leave this view
    // unpainted after its subscribe callbacks (see app.component.ts for the full note).
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
    imports: [WebcamModule, NgbModule, DndModule, TooltipModule, NgClass, NgStyle],
    templateUrl: './product-detail.component.html',
    styleUrl: '../../../admin-core/components/product-detail-section/product-detail-section.component.css'
})
export class ProductDetailComponent implements OnInit, OnChanges, OnDestroy {
    @Input() modelOrder: any;
    @Input() isOrderCancel: any;
    @Input() users: any;
    @Input() selectedUsers: any;
    @Input() removedUsers: any;
    @Input() productDetail: any;
    @Input() loginUserId: any;
    @Input() s3BucketImageURL: any
    @Input() isPreview: any
    @Input() isStickyHeader: boolean = false; // ✅ Enable/disable sticky table header
    @Output("itemSidebarEvent") itemSidebarEvent: EventEmitter<any> = new EventEmitter();
    @Output("getSampleEvent") getSampleEvent: EventEmitter<any> = new EventEmitter();
    @Output("initializeQuillEditorEvent") initializeQuillEditorEvent: EventEmitter<any> = new EventEmitter();
    @Output("quantityChangeEvent") quantityChangeEvent: EventEmitter<any> = new EventEmitter();
    @ViewChildren('editorContainer') editorContainers: QueryList<ElementRef>;
    @ViewChild('skuInput', {static: false}) skuInputElement!: ElementRef;
    constants = Constants;
    isLoading = false;
    @Inject(PLATFORM_ID) private platformId: any;
    isQuillEditorInitialized: boolean = false;
    draggedProductIndex: any = null;
    hoveredProductIndex: any = null;
    destroy$ = new Subject<void>();
    timer: any;
    private debounceTimer: any;
    sampleProductSku: string = '';
    hasExcessQuantityProduct: boolean = false;
    hasProductCommentAdded = model(false);
    modalRef?: BsModalRef;
    @Input() orderId: any
    isDisplaySplitDeliveryBtn: boolean = true;
    @Output("submitRequestEvent") submitRequestEvent: EventEmitter<any> = new EventEmitter();
    @Output("loadingChangeEvent") loadingChangeEvent: EventEmitter<boolean> = new EventEmitter();
    is_editable = true;

    constructor(
        private alertService: AlertService,
        private modalService: BsModalService,
        private subscribersService: SubscribersService,
        public helperFunction: HelperService,
        private productService: ProductsService,
        private modalService1: NgbModal,
        private orderService: QuoteOrderSampleService,
        private quoteService: QuoteService,
        private router: Router,
        private modalServices: BsModalService,
        private sampleRequestUpdateService: SampleRequestUpdateService,
        private debugLogger: DebugLoggerService,
    ) {

    }

    ngOnInit() {
        this.hasExcessQuantityProduct = false;
        if (this.modelOrder?.quote_product) {
            this.hasExcessQuantityProduct = this.modelOrder.quote_product.some(item => +item.quantity > +item.packed_quantity);
            this.hasProductCommentAdded.set(this.modelOrder.quote_product.some(item => item.note?.trim()));
        }

        // Listen for product deletion events from scan product modal
        this.sampleRequestUpdateService.getProductDeletedObservable().pipe(takeUntil(this.destroy$)).subscribe((event: any) => {
            if (event && event.productId) {
                // Update the local modelOrder to reflect the packed quantity changes
                const productIndex = this.modelOrder.quote_product.findIndex(
                    (item: any) => item.product_id === event.productId
                );
                if (productIndex !== -1) {
                    this.modelOrder.quote_product[productIndex].packed_quantity = 0;
                    // Recalculate excess quantity status
                    this.hasExcessQuantityProduct = false;
                    if (this.modelOrder?.quote_product) {
                        this.hasExcessQuantityProduct = this.modelOrder.quote_product.some(item => +item.quantity > +item.packed_quantity);
                    }
                }
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['modelOrder'] && changes['modelOrder'].currentValue) {
            this.hasExcessQuantityProduct = false;
            if (this.modelOrder?.quote_product) {
                this.hasExcessQuantityProduct = this.modelOrder.quote_product.some(item => +item.quantity > +item.packed_quantity);
                this.hasProductCommentAdded.set(this.modelOrder.quote_product.some(item => item.note?.trim()));
            }
        }
    }

    ngAfterViewInit() {
        if (!this.isQuillEditorInitialized && this.isPreview) {
            this.initializeQuillEditorEvent.emit(this.editorContainers);
            this.isQuillEditorInitialized = true;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    toggle(event: MouseEvent) {
        event.preventDefault();
        this.itemSidebarEvent.emit(event);
    }

    productImage(productsRow: any) {
        let sampleProductImages = productsRow?.product?.sample_product?.sample_product_image;
        if (sampleProductImages?.length) {
            const imageUrl = sampleProductImages.find(img => img.type === 'FHI' && img.status === 'A');
            return imageUrl?.path ? Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL + '/' + imageUrl.path + Constants.IMAGE_SIZE_62_X_62 : '';
        }
        return '';
    }

    isDisplayMarkIcon(productsRow) {
        const {packed_quantity, quantity} = productsRow || {};
        return (packed_quantity != null && packed_quantity !== '' && quantity != null && quantity !== '' && +packed_quantity >= +quantity);
    }

    generateSticker(productsRow) {
        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES) {
            this.alertService.error(Constants.UNABLE_SAMPLE_ORDER_DETAIL_CHANGE);
            return;
        }

        this.isLoading = true;
        this.loadingChangeEvent.emit(true);

        this.productService.generateSticker(productsRow.product_id).subscribe({
            next: (response: any) => {
                // if (isPlatformBrowser(this.platformId)) {
                    window.open(response, '_blank');
                // }
                this.isLoading = false;
                this.loadingChangeEvent.emit(false);
            },
            error: () => {
                this.isLoading = false;
                this.loadingChangeEvent.emit(false);
            }
        });
    }

    copySku(sampleSku: string) {
        if (sampleSku) {
            const selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = sampleSku;

            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            document.body.removeChild(selBox);

            this.alertService.success(Constants.SKU_COPIED);
        }
    }

    getCommentTooltip(comment: any): string {
        const htmlRegex = /<[^>]*>/g;
        let tempComment = comment ? comment.replace(htmlRegex, '').trim() : '';
        if (!tempComment) {
            return 'No comment added';
        }
        return comment ? comment : 'No comment added';
    }

    toggleCommentIcon(productsRow) {
        productsRow.isCommentExpanded = !productsRow.isCommentExpanded;
        this.initializeQuillEditorEvent.emit(this.editorContainers);
        // if (!this.isQuillEditorInitialized) {
        //   // this.initializeQuillEditor();
        //   this.initializeQuillEditorEvent.emit(this.editorContainers);
        //   this.isQuillEditorInitialized = true; // Set the flag after initialization
        // }
    }

    displayAllComments() {
        if (!this.isQuillEditorInitialized) {
            this.initializeQuillEditorEvent.emit(this.editorContainers);
            this.isQuillEditorInitialized = true;
        }

        const comments = this.modelOrder.quote_product?.filter(
            (item) => item.note && item.note.trim()
        );

        if (comments.length > 0) {
            const anyCommentExpanded = comments.some((item) => item.isCommentExpanded);

            comments.map((item) => {
                item.isCommentExpanded = anyCommentExpanded ? item.note.trim() && !item.isCommentExpanded : true;
            });
        } else {
            this.alertService.error(Constants.NO_COMMENTS_AVAILABLE_ERROR_MESSAGE);
        }
    }

    openSampleImageModal(productId: any, productsRow) {
        if (this.modelOrder?.status?.short_name == Constants.SAMPLE_ORDER_CANCELLED_SHORT || this.modelOrder.status.short_name == Constants.SAMPLE_ORDER_CONVERSION_PENDING_SHORT || this.modelOrder.status.short_name == Constants.SAMPLE_ORDER_CONVERTED_SHORT || this.modelOrder.status.short_name == Constants.SAMPLE_ORDER_UNCONVERTED_SHORT) {
            return;
        }
        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES) {
            this.alertService.error(Constants.UNABLE_SAMPLE_ORDER_DETAIL_CHANGE);
            return;
        }
        const instance = this.modalService1.open(UploadSamplePackingImageModalNewComponent,
            {
                centered: false,
                windowClass: 'update-contact-modal upload-product-image-modal',
            }
        );
        instance.componentInstance.productId = productId;
        instance.componentInstance.productsRow = productsRow;
        instance.closed.subscribe((result) => {
            if (result) {
                this.getSampleEvent.emit(false);
            }
        });
    }

    onProductRowDrop(event: DndDropEvent, targetRow: any) {
        this.draggedProductIndex = null;
        const draggedProduct = event.data;
        const droppedOnProduct = targetRow;

        const draggedIndex = this.modelOrder.quote_product.findIndex(
            (product) => product.id === draggedProduct.id
        );
        const droppedIndex = this.modelOrder.quote_product.findIndex(
            (product) => product.id === droppedOnProduct.id
        );

        if (draggedIndex !== -1 && droppedIndex !== -1 && draggedIndex !== droppedIndex) {
            if (draggedIndex < droppedIndex) {
                this.modelOrder.quote_product.forEach((product, index) => {
                    if (index > draggedIndex && index <= droppedIndex) {
                        product.order_index -= 1;
                    }
                });
            } else {
                this.modelOrder.quote_product.forEach((product, index) => {
                    if (index >= droppedIndex && index < draggedIndex) {
                        product.order_index += 1;
                    }
                });
            }

            this.modelOrder.quote_product[draggedIndex].order_index = droppedIndex + 1;
            this.modelOrder.quote_product.forEach((product) => {
                product.isCommentExpanded = false;
            });
            this.modelOrder.quote_product.sort(
                (a, b) => a.order_index - b.order_index
            );

            this.modelOrder.quote_product.forEach((product, index) => {
                this.quoteService.updateQuoteProduct(
                    {order_index: product.order_index},
                    product.id
                ).pipe(takeUntil(this.destroy$))
                    .subscribe((response) => {
                        if (response) {
                            if (index === this.modelOrder.quote_product.length - 1) {
                                this.alertService.success(Constants.PRODUCT_ORDER_SEQUENCE_UPDATE_SUCCESS_MESSAGE);
                                this.initializeQuillEditorEvent.emit(true);
                            }
                        }
                    });
            });
        } else {
            this.draggedProductIndex = null;
        }
    }

    onProductRowDragStart(productRow: any) {
        this.draggedProductIndex = productRow.order_index;
    }

    onProductRowDragEnd(event: any) {
        this.draggedProductIndex = null;
        // this.changeDetection.detectChanges();
    }

    onProductRowDragOver(event: any, targetRow: any) {
        event.preventDefault();
        const hoverProduct = targetRow;
        const hoverIndex = hoverProduct.order_index;

        if (this.hoveredProductIndex !== hoverIndex) {
            this.hoveredProductIndex = hoverIndex;
            // this.changeDetection.detectChanges();
        }
    }

    checkQuantityOnKeyPress(productsRow: any, qtyChangeType: any, enteredQuantity: any = 0) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.checkQuantity(productsRow, qtyChangeType, enteredQuantity);
        }, 1500);
    }

    checkQuantity(productsRow: any, qtyChangeType: any, enteredQuantity: any = 0) {
        const quoteStatus = this.modelOrder?.status?.short_name;

        if (quoteStatus === this.constants.SAMPLE_ORDER_DELIVERED_SHORT || quoteStatus === this.constants.SAMPLE_ORDER_COMPLETED_SHORT) {
            return false;
        }

        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES && this.modelOrder?.status?.short_name !== Constants.SAMPLE_ORDER_UNCONVERTED_SHORT) {
            this.alertService.error(Constants.UNABLE_SAMPLE_ORDER_DETAIL_CHANGE);
            return false;
        }

        const currentQtyValue = productsRow?.packed_quantity;

        if (
            (currentQtyValue <= 0 && qtyChangeType === 'decrement') ||
            (enteredQuantity === 0 && qtyChangeType === 'text')
        ) {
            // const message = `This product has a minimum order packed quantity of 1 ${productsRow?.product.unit_of_measurement_name}`;
            const message = `The product's quantity should not be negative.`;
            productsRow.packed_quantity = Number(currentQtyValue).toFixed();
            this.alertService.error(message);
            return;
        }

        if (qtyChangeType === 'increment') {
            /*if ((Number(productsRow?.packed_quantity) + 1) > Number(productsRow?.quantity)) {
              this.alertService.error(Constants.PACKED_QUANTITY_EXCEEDS_MESSAGE);
              return false;
            }*/
            productsRow.packed_quantity = +currentQtyValue + 1;
            // productsRow.quantity = (+currentQtyValue + 1);
        } else if (qtyChangeType === 'decrement' && currentQtyValue > 0) {
            productsRow.packed_quantity = Math.max(+currentQtyValue - 1, 0);
            // productsRow.quantity = Math.max(+currentQtyValue - 1, 0);
        } else if (qtyChangeType === 'text') {
            /*if (Number(enteredQuantity) > Number(productsRow?.quantity)) {
              this.alertService.error(Constants.PACKED_QUANTITY_EXCEEDS_MESSAGE);
              return false;
            }*/
            productsRow.packed_quantity = enteredQuantity;
            // productsRow.quantity = (+currentQtyValue + 1);
        }
        // this.changeDetection.detectChanges();

        const json = {
            id: productsRow.id,
            quote_id: productsRow.quote_id,
            product_id: productsRow?.product_id,
            quantity: productsRow.quantity,
            price: productsRow?.price,
            packed_quantity: productsRow.packed_quantity,
        };

        // Debounce logic here
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.quantityChangeEvent.emit(json);
            this.hasExcessQuantityProduct = false;
            if (this.modelOrder?.quote_product) {
                this.hasExcessQuantityProduct = this.modelOrder.quote_product.some(item => +item.quantity > +item.packed_quantity);
            }
            // this.updateSampleQuantity(json);
            // this.checkAllProductScannedOrNot();
        }, 500);
    }

    restrictToDigits(event: KeyboardEvent): void {
        const charCode = event.charCode || event.keyCode;
        // Allow only digits (0-9)
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    }

    removeProduct(product: any) {
        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES && this.modelOrder?.status?.short_name !== Constants.SAMPLE_ORDER_UNCONVERTED_SHORT) {
            this.alertService.error(Constants.UNABLE_SAMPLE_ORDER_DETAIL_CHANGE);
            return false;
        }
        if (this.modelOrder.quote_product.length > 1) {
            let modalRef: any = this.modalService.show(ConfirmModalComponent);
            modalRef.content.title = 'Confirm Delete Product';
            modalRef.content.message = Constants.DELETE_PRODUCT_FROM_SAMPLE_REQUEST_CONSTANTS.BODY_MESSAGE;
            modalRef.setClass('delete-favourite-modal');
            modalRef.content.onClose.pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
                if (result) {
                    this.isLoading = true;
                    this.quoteService.deleteQuoteProduct(product.id).pipe(takeUntil(this.destroy$)).subscribe(() => {
                        this.getSampleEvent.emit(false);
                        this.isLoading = false;
                        this.alertService.success(Constants.SAMPLE_REQUEST_MESSAGE_CONSTANTS.PRODUCT_REMOVE);
                    }, (error: any) => {
                        if (error.message) {
                            this.alertService.error(error.message);
                        }
                    });
                } else {
                    this.isLoading = false;
                }
            });
        } else {
            this.alertService.info(this.constants.SAMPLE_REQUEST_MESSAGE_CONSTANTS.PRODUCT_RESTRICTION_FOR_LAST_PRODUCT);
        }
    }

    onSkuInput(event: KeyboardEvent) {
        const input = (event.target as HTMLInputElement).value;
        this.sampleProductSku = input.trim();
    }

    onSkuEnterPress() {
        if (this.sampleProductSku && this.sampleProductSku.length > 0) {
            const trimmedSku = this.sampleProductSku.trim();
            const matchingProduct = this.modelOrder.quote_product.find(
                (item) => item.product?.sample_product?.sku === trimmedSku
            );
            if (matchingProduct) {
                matchingProduct.packed_quantity = (Number(matchingProduct.packed_quantity) || 0) + 1;

                // Reset input and focus
                this.sampleProductSku = '';
                this.focusInput();

                // Emit the updated quantity
                const json = {
                    id: matchingProduct.id,
                    quote_id: matchingProduct.quote_id,
                    product_id: matchingProduct.product_id,
                    quantity: matchingProduct.quantity,
                    price: matchingProduct.price,
                    packed_quantity: matchingProduct.packed_quantity,
                };
                this.quantityChangeEvent.emit(json);
            } else {
                let isDisplayAddProductBySkuPopup = true;
                this.getProductBySku(this.sampleProductSku).subscribe((data: any) => {
                    if (data && data.length > 0) {
                        this.modalRef = this.modalServices.show(ConfirmModalComponent, {
                            initialState: {
                                title: Constants.VALID_SKU_MESSAGES.TITLE,
                                message: Constants.VALID_SKU_MESSAGES.BODY_MESSAGE
                            },
                            class: 'delete-favourite-modal',
                            backdrop: true,
                            keyboard: false,
                            ignoreBackdropClick: true,
                        });
                        this.modalRef.content.isDisplayAddProductBySkuPopup = isDisplayAddProductBySkuPopup;
                        this.modalRef.content.onClose.subscribe((result: any) => {

                            if (result) {
                                let json = {
                                    quote_id: this.orderId,
                                    product_id: data[0].id,
                                    quantity: data[0]?.sampleProduct?.moi,
                                    price: data[0].price,
                                    packed_quantity: Constants.ADD_PRODUCT_DEFAULT_PACKED_QUANTITY,
                                    useFor: 'add_product'
                                }
                                this.quantityChangeEvent.emit(json);
                            }
                            this.sampleProductSku = ''
                        });
                    } else {
                        const errorMessage = Constants.INVALID_SKU_ERROR_MESSAGE;
                        this.speakInvalidSkuErrorMessage(errorMessage);
                        this.focusInput();

                        this.modalRef = this.modalServices.show(ConfirmModalComponent, {
                            initialState: {
                                title: Constants.INVALID_SKU_MESSAGES.TITLE,
                                message: Constants.INVALID_SKU_MESSAGES.BODY_MESSAGE
                            },
                            class: 'delete-favourite-modal',
                            backdrop: true,
                            keyboard: false,
                            ignoreBackdropClick: true,
                        });
                        this.modalRef.content.invalidSku = true;
                        this.modalRef.content.onClose.subscribe((result: any) => {
                            if (result) {
                                this.sampleProductSku = ''
                            }
                        });
                    }
                });
            }
        }
    }

    getProductBySku(sampleProductSku: any) {
        let sampleSku = sampleProductSku.trim();
        const requestParamModel = new RequestParamModel();
        requestParamModel.fields = ['id', 'price', 'main_sample_sku', 'sampleProduct.moi']
        requestParamModel.expand = ['sampleProduct']
        requestParamModel.addDefaultFilter('main_sample_sku', sampleSku, 'number');
        requestParamModel.sortChange('id', 'desc');
        return this.productService.getProduct(requestParamModel).pipe(
            map((dataList: any) => {
                if (dataList.data && dataList.data.length > 0) {
                    return dataList.data;
                }
                return [];
            })
        );
    }

    speakInvalidSkuErrorMessage(message: string) {
        if (window?.speechSynthesis) {
            const utterance = new SpeechSynthesisUtterance(message);
            utterance.lang = 'en-US';
            speechSynthesis.speak(utterance);
        } else {
            this.alertService.error(message);
        }
    }

    handleSampleRequestAction(sampleId: number, isDisplaySplitDeliveryBtn?: boolean) {
        let isPackedQuantityZero = this.modelOrder.quote_product.every(item => (!item.packed_quantity || item.packed_quantity == 0));
        if (isPackedQuantityZero && isDisplaySplitDeliveryBtn) {
            this.alertService.error(Constants.ERROR_MESSAGE_ZERO_QUANTITY_PRODUCTS);
            return;
        }
        this.modalRef = this.modalService.show(ConfirmModalComponent);
        if (isDisplaySplitDeliveryBtn) {
            this.modalRef.content.title = 'Confirm Split Delivery Sample Request';
            this.modalRef.content.message = Constants.SPLIT_DELIVERY_SAMPLE_CONSTANTS.BODY_MESSAGE;
            this.modalRef.content.note = Constants.SPLIT_DELIVERY_SAMPLE_CONSTANTS.SPLIT_CONDITION_NOTE;
        } else {
            this.modalRef.content.title = 'Confirm Clone Sample Request';
            this.modalRef.content.message = Constants.CLONE_SAMPLE_CONSTANTS.BODY_MESSAGE;
        }

        this.modalRef.setClass('delete-favourite-modal');
        this.modalRef.content.onClose.subscribe(async (result: any) => {
            if (result) {
                this.loadingChangeEvent.emit(true);
                if (isDisplaySplitDeliveryBtn) {
                    this.submitRequestEvent.emit()
                } else {
                    this.loadingChangeEvent.emit(false);
                    let url = `sample-requests/clone/${sampleId}`;
                    this.router.navigate([url]);
                }
            } else {
                this.loadingChangeEvent.emit(false);
            }
        });
    }

    onProductOrderChanged($event: any) {
        // this.debugLogger.log('onProductOrderChanged $event', $event);
    }


    focusInput() {
        setTimeout(() => {
            if (this.skuInputElement) {
                this.skuInputElement.nativeElement.focus();
            }
        }, 0);
    }

    openSliderModal(quoteProduct: number) {
        const instance = this.modalService1.open(ProductImageSliderModalComponent, {
            windowClass: 'imageEnlarge',
            centered: false,
            size: 'xl',
        });
        instance.componentInstance.selectedQuoteProduct = quoteProduct;
    }

    openProductNotesModal(productsRow: any, event: MouseEvent) {
        event.stopPropagation();
        const instance = this.modalService1.open(UpdateSampleProductNotesModalComponent, {
            centered: true,
            windowClass: 'update-project-popup',
            keyboard: true,
        });
        instance.componentInstance.productsRow = productsRow;
        instance.componentInstance.loginUserId = this.loginUserId;
        instance.closed.subscribe((result: any) => {
            if (result && result.short_description !== undefined) {
                if (!productsRow.product.sample_product.sample_product_description) {
                    productsRow.product.sample_product.sample_product_description = {};
                }
                productsRow.product.sample_product.sample_product_description.short_description = result.short_description;
            }
        });
    }

    getSampleImage(product_image: any): string {
        const getKitPath = this.constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL;
        if (product_image != '' && product_image != null) {
            return (
                getKitPath +
                '/UPLOAD_SAMPLES_PACKING_IMAGES/' +
                product_image +
                this.constants.IMAGE_SIZE_50_X_50
            );
        }
        return null;
    }

    deleteSamplePackingImage(sampleImageId: any) {
        if (this.modelOrder?.status?.short_name == Constants.SAMPLE_ORDER_CANCELLED_SHORT) {
            return;
        }
        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_TRUE) {
            this.alertService.error(Constants.UNABLE_SAMPLE_ORDER_DETAIL_CHANGE);
            return;
        }
        this.modalRef = this.modalService.show(ConfirmModalComponent);
        this.modalRef.content.title = 'Confirm Delete Sample Image';
        this.modalRef.content.message =
            Constants.DELETE_SAMPLE_REQUEST_IMAGE_CONSTANTS.BODY_MESSAGE;
        this.modalRef.setClass('delete-favourite-modal');

        this.modalRef.content.onClose.pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
            if (result) {
                this.orderService.deleteSamplePackingImage(sampleImageId).pipe(takeUntil(this.destroy$)).subscribe(
                    () => {
                        this.getSampleEvent.emit(false);
                        this.alertService.success(
                            Constants.SAMPLE_IMAGE_DELETE_SUCCESSFULLY
                        );
                    },
                    () => {
                    }
                );
            }
        });
    }

    getSizingDimensions(product: any): string {
        if (product) {
            const sizingDimensions: string[] = [];

            // Helper to remove 'mm' (case insensitive) and spaces from any value
            const cleanValue = (val: string) => val.replace(/mm/gi, '').trim();

            // 1. Clean Length
            if (product.length && product.length.trim() !== '') {
                sizingDimensions.push(cleanValue(product.length));
            }

            // 2. Clean Width
            if (product.width && product.width.trim() !== '') {
                sizingDimensions.push(cleanValue(product.width));
            }

            // // 3. Clean Thickness
            // if (product.thickness && product.thickness.trim() !== '') {
            //     sizingDimensions.push(cleanValue(product.thickness));
            // }

            const result = sizingDimensions.join(' x ');

            if (!result) {
                return '';
            }

            // Get the last item added (e.g., "30" or "French Pattern")
            const lastItem = sizingDimensions[sizingDimensions.length - 1];

            // Check if the last item contains any digit (0-9)
            // "30" -> true
            // "30.5" -> true
            // "XL French Pattern" -> false
            const hasNumber = /\d/.test(lastItem);

            // If the last part has a number, add 'mm', otherwise return just the string
            return hasNumber ? result + ' mm' : result;
        }
        return '';
    }
}
